import { buildNavigationUrl } from "../../../util/buildNavigationUrl";
const ARTIST_LIST_CONTEXT_KEYS = ["listId", "workingListId"];

const getArtistListContext = search => {
  const query = new URLSearchParams(search);

  return Object.fromEntries(
    ARTIST_LIST_CONTEXT_KEYS.flatMap(key => {
      const value = query.get(key);
      return value ? [[key, value]] : [];
    }),
  );
};

const buildArtistListUrl = ({ listContext = {}, status = "all" } = {}) => {
  const query = new URLSearchParams(
    status && status !== "all" ? { status } : {},
  );

  ARTIST_LIST_CONTEXT_KEYS.forEach(key => {
    if (listContext[key]) query.set(key, listContext[key]);
  });

  return buildNavigationUrl("/artist", query);
};

const buildArtistNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) =>
  buildNavigationUrl(
    `/artist/${recordId}/${activeSubPage || "details"}`,
    buildArtistListUrl({
      listContext,
      status,
    }).split("?")[1] || "",
  );

export {
  ARTIST_LIST_CONTEXT_KEYS,
  buildArtistListUrl,
  buildArtistNavigationTargetUrl,
  getArtistListContext,
};
